import React from 'react'
import { ButtonToolbar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import TextInput from 'components/ui/forms/field/text-input/TextInput'
import styles from './SurveyDetails.module.scss'
import TextAreaInput from 'components/ui/forms/field/text-area/TextArea'
import Button from 'design-system/button'
import { ButtonVariant, ButtonSizes } from 'design-system/button/src/Button'
import { IBlockInstanceModel } from 'models/block.model'

interface ISurveyDetails {
  values: IBlockInstanceModel
  onChange: (values: IBlockInstanceModel) => void
  onNext: () => void
  onCancel: () => void
  errors: Record<string, string>
}

const SurveyDetails: React.FC<ISurveyDetails> = ({
  onNext,
  onCancel,
  onChange,
  values,
  errors,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <div className={'d-flex flex-column'}>
        <h1 className={`mb-2 ${styles.title}`}>
          {t('administration.blocks.type.survey.surveyDetails')}
        </h1>
        <div className={'w-50 mb-4'}>
          <TextInput
            name={'name'}
            placeHolder=""
            label={t('administration.blocks.type.survey.title')}
            value={values['name']}
            onChange={(e) => onChange({ ...values, ['name']: e.target.value })}
            error={errors['name']}
          />
        </div>
        <div className={'w-100 mb-5'}>
          <TextAreaInput
            name={'description'}
            rows={3}
            label={t('administration.blocks.type.survey.description')}
            value={values['description']}
            onChange={(e) =>
              onChange({ ...values, ['description']: e.target.value })
            }
            error={errors['description']}
          />
        </div>
      </div>
      <ButtonToolbar className="float-right mt-5">
        <Button
          onClick={onCancel}
          variant={ButtonVariant.Secondary}
          size={ButtonSizes.Small}
        >
          {t('administration.blocks.type.survey.buttons.close')}
        </Button>
        <Button
          size={ButtonSizes.Small}
          onClick={() => onNext()}
          className="mr-0"
        >
          {t('administration.blocks.type.survey.buttons.next')}
        </Button>
      </ButtonToolbar>
    </>
  )
}

export default SurveyDetails
